import CommonConfig from "./constant";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Shared/Toast/Toast";

export const useCatchResponse = () => {
    const navigate = useNavigate();
    const catchResponse = async (error) => {
        const axiosError = error;
        if (axiosError?.statusCode === 401) {
            CommonConfig.handleCatchLogout(navigate);
            Toast.error({ message: axiosError?.message });
        } else if (axiosError?.statusCode === 400) {
            Toast.error({ message: axiosError?.message });
        } else if (axiosError?.statusCode === 404) {
            Toast.error({ message: axiosError?.message });
        } else if (axiosError?.statusCode === 403) {
            Toast.error({ message: axiosError?.message });
        } else if (axiosError?.statusCode === 500) {
            Toast.error({ message: axiosError?.message });
            // CommonConfig.handleCatchLogout(navigate);
        } else {
            Toast.error({ message: axiosError?.message || 'An error occurred.' });
        }
    };

    return { catchResponse };
};
